// Matches `col-[50%]`, `col-[33.3333%]`, `max-md:col-[30%]`, `max-xl:col-[20%]`.
// Does not match fraction presets like `col-[4/12]`.
const COL_PERCENTAGE_CLASS_PATTERN = /(?:[\w-]+:)?col-\[[\d.]+%\]/;

const hasColPercentageClass = (classAttributeValue) =>
  COL_PERCENTAGE_CLASS_PATTERN.test(classAttributeValue || '');

export default hasColPercentageClass;
